import { render, staticRenderFns } from "./verticalTable.vue?vue&type=template&id=ecf6fe4c&scoped=true"
import script from "./verticalTable.vue?vue&type=script&lang=js"
export * from "./verticalTable.vue?vue&type=script&lang=js"
import style0 from "./verticalTable.vue?vue&type=style&index=0&id=ecf6fe4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf6fe4c",
  null
  
)

export default component.exports